<div class="page-content page-fill">
  @if (nominations && people) {
    <div>
      <div class="row">
        <div class="col-sm-3">
          <h2 style="text-align: center">Nomination Entry</h2>
          <div class="row">
            <dx-form class="mb-3" [formData]="nomination" validationGroup="statusChangeData" [colCount]="2">
              <dxi-item
                #personSelect
                dataField="personId"
                [colSpan]="2"
                [label]="{ text: 'Person' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: people, valueExpr: 'id', displayExpr: 'displayName', searchEnabled: true, searchMode: 'contains' }"
              ></dxi-item>
              <dxi-item
                dataField="role"
                [colSpan]="2"
                [label]="{ text: 'Role' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: roles, searchEnabled: true, searchMode: 'startswith' }"
              ></dxi-item>
            </dx-form>
            <dx-data-grid
              #nominationGrid
              keyExpr="id"
              class="nominations-grids"
              [dataSource]="nominations"
              [columnAutoWidth]="false"
              (onToolbarPreparing)="onToolbarPreparing($event)"
              (onSelectionChanged)="onSelectionChange($event)"
              [focusedRowEnabled]="false"
              [showBorders]="true"
              [height]="700"
              >
              <dxi-column dataField="person.displayName" caption="Name" width="175"></dxi-column>
              <dxi-column dataField="role" caption="Role" width="150"></dxi-column>
              <dxi-column dataField="id" caption="Entered" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
              <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" (click)="add()" class="btn btn-primary" [disabled]="addProcessing || !nomination.personId">Add Nomination</button>
                <button
                  type="button"
                  (click)="deleteNomination()"
                  class="btn btn-sm btn-danger ms-4"
                  [disabled]="nominationGrid.instance.getSelectedRowsData().length !== 1"
                  >
                  Delete
                </button>
              </div>
              <div *dxTemplate="let data of 'toolbarText'">
                @if (nominations) {
                  <span class="me-3"
                    ><strong>{{ nominationGrid.instance.totalCount() + ' items' }}</strong></span
                    >
                  }
                </div>
                <dxo-selection [mode]="'multiple'"></dxo-selection>
              </dx-data-grid>
            </div>
          </div>
          <div class="ms-3 col-sm-3">
            <h2 style="text-align: center">Nomination Grouping</h2>
            <div class="row">
              <dx-form class="mb-3" [formData]="assignment" validationGroup="statusChangeData" [colCount]="2">
                <dxi-item
                  dataField="role"
                  [colSpan]="2"
                  [label]="{ text: 'Role' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: roles, searchEnabled: true, searchMode: 'startswith' }"
                ></dxi-item>
              </dx-form>
              <dx-data-grid
                #groupGrid
                keyExpr="id"
                class="nominations-grids"
                [dataSource]="nominationGroups"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChange($event)"
                [focusedRowEnabled]="false"
                [showBorders]="true"
                [height]="750"
                >
                <dxi-column dataField="name" caption="Name" width="175"></dxi-column>
                <dxi-column dataField="deacon" width="80"></dxi-column>
                <dxi-column dataField="shepherding" width="100"></dxi-column>
                <dxi-column dataField="executive" width="80"></dxi-column>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  <button type="button" (click)="getGroupedData()" class="btn btn-primary">Refresh</button>
                  <button type="button" (click)="confirm()" [disabled]="!assignment.role" class="ms-2 btn btn-danger">Assign</button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  @if (nominationGroups) {
                    <span class="me-3"
                      ><strong>{{ groupGrid.instance.totalCount() + ' items' }}</strong></span
                      >
                    }
                  </div>
                  <dxo-export [enabled]="true"></dxo-export>
                  <dxo-selection [mode]="'multiple'"></dxo-selection>
                </dx-data-grid>
              </div>
            </div>
            <div class="ms-3 col-sm-4">
              <h2 style="text-align: center">Nomination Assignments</h2>
              <div class="row">
                <dx-form class="mb-3" [formData]="assignment" validationGroup="statusChangeData" [colCount]="2">
                  <!-- <dxi-item
                  dataField="role"
                  [colSpan]="2"
                  [label]="{ text: 'Role' }"
                  editorType="dxSelectBox"
                  [editorOptions]="{ items: roles, searchEnabled: true, searchMode: 'startswith' }"
                ></dxi-item> -->
              </dx-form>
              <dx-data-grid
                #assignmentGrid
                keyExpr="id"
                class="nominations-grids"
                [dataSource]="assignments"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChange($event)"
                [focusedRowEnabled]="false"
                [showBorders]="true"
                [height]="800"
                >
                <dxi-column dataField="person.displayName" caption="Name" width="175" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column dataField="role" width="150" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column dataField="status" width="150" cellTemplate="colorTemplate"></dxi-column>
                <dxi-column width="100"></dxi-column>
                <div *dxTemplate="let data of 'toolbarButtons'">
                  <button type="button" (click)="printNominationForm()" class="btn btn-primary">Print Letters</button>
                  <button
                    type="button"
                    (click)="markAssignment('Delete')"
                    [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                    class="ms-2 btn btn-danger"
                    >
                    Remove
                  </button>
                  <button
                    type="button"
                    (click)="markAssignment('Accept')"
                    [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                    class="ms-3 btn btn-sm btn-primary"
                    >
                    Accepted
                  </button>
                  <button
                    type="button"
                    (click)="markAssignment('Decline')"
                    [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                    class="ms-2 btn btn-sm btn-danger"
                    >
                    Declined
                  </button>
                  <button
                    type="button"
                    (click)="markAssignment('Clear')"
                    [disabled]="assignmentGrid.instance.getSelectedRowsData().length === 0"
                    class="ms-2 btn btn-sm btn-warning"
                    >
                    Clear
                  </button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                  @if (assignments) {
                    <span class="me-3"
                      ><strong>{{ assignmentGrid.instance.totalCount() + ' items' }}</strong></span
                      >
                    }
                  </div>
                  <div *dxTemplate="let cell of 'colorTemplate'">
                    <div class="{{ cell.data.accepted ? 'accepted' : cell.data.declined ? 'declined' : '' }}">
                      {{ cell.text }}
                    </div>
                  </div>
                  <dxo-export [enabled]="true"></dxo-export>
                  <dxo-filter-row [visible]="true"></dxo-filter-row>
                  <dxo-selection [mode]="'multiple'"></dxo-selection>
                </dx-data-grid>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
